module.exports = __webpack_public_path__ + "static/media/Coins_Mail_Icon@3x.f02296c9.png";